import React from 'react';
import { Flex, Text, Icon } from '@spothero/ui';
import IconStar from '@spothero/icons/star-filled';
/*
Logic for displaying star rating with category:
Amount of reviews displayed as rounded abbreviated number.
If there are less than 1,000 ratings then show full number (e.g. 999)
If there are 1,000 or more but less than 10,000 show in the format of X.XK
e.g. 1,234 = 1.2K
e.g. 9,352 = 9.4K
The first digit represents the thousands, the second digit represents the hundreds.
Round to nearest hundred.
If there are 10,000 or more, show as an integer number of thousands followed by K
e.g. 10,001 = 10K
e.g. 52,792 = 53K
Round to nearest thousand with no decimal places.
 */
export const getNumberOfReviews = (numberOfReviews) => {
    if (numberOfReviews < 1000) {
        return numberOfReviews;
    }
    if (numberOfReviews < 10000) {
        return `${(numberOfReviews / 1000).toFixed(1)}K`;
    }
    return `${Math.round(numberOfReviews / 1000)}K`;
};
const StarRatingWithCategory = ({ numberOfReviews, starRating, countStyles = {}, }) => {
    if (numberOfReviews < 10) {
        return <div className="StarRatingWithCategory"/>;
    }
    return (<Flex data-testid="StarRatingWithCategory" marginTop={1} alignItems="center">
            <Icon as={IconStar} color="yellow.400" marginRight={0.5}/>
            <Text as="span" color="black" paddingRight={1} fontSize="sm" data-testid="StarRatingWithCategory-StarRating">
                {starRating.toFixed(1)}
            </Text>
            <Text as="span" color="gray.dark" fontSize="sm" data-testid="StarRatingWithCategory-Reviews" {...countStyles}>
                ({getNumberOfReviews(numberOfReviews)})
            </Text>
        </Flex>);
};
StarRatingWithCategory.defaultProps = {
    numberOfReviews: 0,
    starRating: 0,
};
export default StarRatingWithCategory;
